import { Box } from "@mui/material";

interface TabPanelProps {
  children?: React.ReactNode;
  value: string;
  tab: string;
}

const TabPanel = (props: TabPanelProps) => {
  const { children, value, tab, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== tab}
      id={`profile-tabpanel-${tab}`}
      aria-labelledby={`profile-tab-${tab}`}
      {...other}
    >
      {value === tab && <Box>{children}</Box>}
    </Box>
  );
};

export default TabPanel;
